'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'BLURB_CUSTOM_CONTENT',
	name: 'Custom Content',
	allowedSections: ['main', 'header'],
	disallowedChildren: [],
	category: 'Blurbs',
	icon: 'fal fa-box-full',
	props: [{
		name: 'blurbUrl',
		inputType: 'link',
		label: 'Landing page url',
		default: '',
		requestKey: 'linkFriendlyName'
	}, {
		name: 'imgSrc',
		inputType: 'media',
		label: 'Image path',
		default: 'kevinmurphy.jpg'
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'List blurb settings',
		props: [{
			name: 'width',
			inputType: 'slider',
			label: 'Width',
			default: '1'
		}, {
			name: 'height',
			inputType: 'slider',
			label: 'Height',
			default: '1'
		}, {
			name: 'position',
			inputType: 'arrows',
			label: 'position',
			values: [{
				name: 'posX',
				label: 'X-Pos',
				default: '1'
			}, {
				name: 'posY',
				label: 'Y-Pos',
				default: '1'
			}]
		}]
	})
};